/*
  Skinstead analytics. Sends GA4 style events through gtag when present, otherwise
  pushes them to window.dataLayer for Google Tag Manager. Turned on and off in
  Theme settings > Skinstead > Analytics.
  - cta_click: any element with data-track="section:label"
  - select_concern: clicks on concern tiles (data-concern)
  - routine_finder_submit: dispatched by the routine finder as an ss:track event
  - view_cart_drawer: when the cart drawer dialog opens
  - begin_checkout: clicks on checkout buttons
  - add_to_cart: Shopify standard cart lines update event (quick add and PDP)
*/
(() => {
  if (window.__ssAnalytics) return;
  window.__ssAnalytics = true;

  const send = (name, params = {}) => {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, params);
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: name, ...params });
      }
    } catch (error) {
      /* never break the page for analytics */
    }
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const tracked = target.closest('[data-track]');
    if (tracked) {
      const [section = '', ...rest] = (tracked.getAttribute('data-track') || '').split(':');
      send('cta_click', { section, label: rest.join(':'), link_url: tracked.getAttribute('href') || '' });
    }

    const concern = target.closest('[data-concern]');
    if (concern) send('select_concern', { concern: concern.getAttribute('data-concern') });

    const checkout = target.closest('[name="checkout"], .cart__checkout-button, a[href*="/checkout"]');
    if (checkout) send('begin_checkout', { currency: window.Shopify?.currency?.active || 'INR' });
  }, { capture: true });

  // Horizon dispatches the Shopify standard event when lines are added (quick add or PDP).
  document.addEventListener('shopify:cart:lines-update', (event) => {
    const detail = event.detail || {};
    if (detail.action && !/add/i.test(String(detail.action))) return;
    send('add_to_cart', { source: detail.source || 'theme' });
  });

  document.addEventListener('ss:track', (event) => {
    const { event: name, ...params } = event.detail || {};
    if (name) send(name, params);
  });

  const watchDrawer = () => {
    const dialog = document.querySelector('cart-drawer-component dialog, .cart-drawer dialog');
    if (!dialog) return;
    new MutationObserver(() => {
      if (dialog.hasAttribute('open')) send('view_cart_drawer', {});
    }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawer);
  } else {
    watchDrawer();
  }
})();
